import { Injectable } from "@angular/core";
import { isPlatform } from "@ionic/core";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public get isBrowser() {
    return this._isBrowser
  }

  private readonly _isBrowser = isPlatform('desktop') || isPlatform('mobileweb')

}
